import axiosInstance from './instance';

const instance = axiosInstance();

export const chat = async (userId, applicationId,messageInput,newMessage) => {
    try {
        const response = await instance.post(`/${userId}/${applicationId}?content=${messageInput}&type=${newMessage.type}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const getchat = async (userId, applicationId ,page,size) => {
    try {
        const response = await instance.get(`/${userId}/commentsByApplicationId/${applicationId}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
